var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.closeModal()
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper modalCards",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeModal()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-container",
                style: { width: _vm.width + "px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    class: ["header-" + _vm.modalType]
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.titulo))
                    ]),
                    _c("div", { staticClass: "header-icon" }),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { id: "btn", type: "text", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.closeModal()
                          }
                        },
                        nativeOn: {
                          mouseover: function($event) {
                            return _vm.hover($event)
                          },
                          mouseout: function($event) {
                            return _vm.leave($event)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons icon" }, [
                          _vm._v("close")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [_vm._t("footer")],
                  2
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ac8974e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac8974e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppModalDashboard.vue
// module id = null
// module chunks = 